import {OdontoGuide} from 'presentation/modules/guide/odonto/ui/pages/OdontoGuide';
import React from 'react';

export const MakeOdontoGuide: React.FC = () => <OdontoGuide />;
